export enum CaptionsTokenType {
  Text,
  // Custom,
  Punctuation
}

export interface CaptionsToken {
  key: string;
  type: CaptionsTokenType;
  start: number; // seconds
  end: number; // seconds
  value: string;
}



// WEBPACK FOOTER //
// ./src/data/CaptionsToken.ts